/* This file was generated by running "node scripts/generateTranslations.js". */
/* Created: 2024-09-25 10:01:34 */

const Keys = {
  menuSnippets: 'menuSnippets',
  menuAudio: 'menuAudio',
  menuCharity: 'menuCharity',
  menuLogout: 'menuLogout'
}; export default Keys;